export const heroSlides = [
  {
    image: 'https://readdy.ai/api/search-image?query=Elegant%20nurse%20themed%20fashion%20photography%2C%20white%20minimal%20background%2C%20soft%20dramatic%20lighting%2C%20high%20fashion%20editorial%20style%2C%20clean%20sophisticated%20aesthetic%2C%20professional%20model%20pose&width=1600&height=900&seq=hero-slide-01&orientation=landscape',
    title: '专业医护美学',
    subtitle: '比基尼护士',
    description: '融合医护专业与时尚美学的创意品牌，为你打造独一无二的视觉与体验',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20spa%20treatment%20scene%2C%20warm%20candlelight%2C%20white%20orchids%2C%20serene%20wellness%20atmosphere%2C%20soft%20cream%20tones%2C%20high%20end%20beauty%20photography&width=1600&height=900&seq=hero-slide-02&orientation=landscape',
    title: '医护级美体护理',
    subtitle: '科学护肤新哲学',
    description: '以严谨的医护标准，呵护你的每一寸肌肤',
  },
];

export const stats = [
  { value: '5000+', label: '满意客户', icon: 'ri-user-heart-line' },
  { value: '300+', label: '主题造型', icon: 'ri-shirt-line' },
  { value: '98%', label: '好评率', icon: 'ri-star-line' },
  { value: '8年', label: '品牌历史', icon: 'ri-award-line' },
];

export const testimonials = [
  {
    name: '小雅',
    location: '上海',
    rating: 5,
    content: '第一次拍摄护士主题写真，超级紧张！但比基尼护士的团队特别专业，从化妆到拍摄全程引导，成片效果超出预期，朋友们都夸好看！',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Asian%20woman%2C%20warm%20smile%2C%20clean%20white%20background%2C%20soft%20natural%20lighting%2C%20headshot%20photography&width=100&height=100&seq=avatar-xiaoya&orientation=squarish',
  },
  {
    name: 'Mia',
    location: '北京',
    rating: 5,
    content: '买了比基尼护士装去漫展，直接被围观拍照！质量没话说，细节做得很到位，比普通的cos服高级太多。已经安利给所有姐妹了！',
    avatar: 'https://readdy.ai/api/search-image?query=Beautiful%20Asian%20woman%20portrait%2C%20confident%20expression%2C%20studio%20headshot%2C%20clean%20background%2C%20professional%20lighting%2C%20fashion%20editorial&width=100&height=100&seq=avatar-mia&orientation=squarish',
  },
  {
    name: '思思',
    location: '广州',
    rating: 5,
    content: '做完面部护理感觉皮肤在发光！她们家的护理师真的懂皮肤，不是随便按按就完事了，每次都会根据我的皮肤状态调整方案。',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Asian%20woman%20headshot%20portrait%2C%20gentle%20smile%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20professional%20corporate%20style&width=100&height=100&seq=avatar-sisi&orientation=squarish',
  },
];